module.exports = "/images/vendor/desiigner-svg/svg/social/telegram.svg?934d727f3a331efe087b25a7914c67cc";